export default defineNuxtPlugin(() => {
  const runtimeConfig = useRuntimeConfig()

  const ruralityAuthConfigScript = document.createElement('script')
  ruralityAuthConfigScript.innerHTML = `
    window.rurality = window.rurality || {};
    window.rurality.auth = window.rurality.auth || {};    
    window.rurality.auth.config = window.rurality.auth.config || {};
    window.rurality.auth.config.client_id = "${runtimeConfig.public.GOOGLE_WEB_CLIENT_ID}";

    window.ER = window.ER || {};
    window.ER.uri = window.ER.uri || {};
    window.ER.uri.main = window.ER.uri.main || {};

    window.ER.uri.prefix = '/'
    window.ER.uri.main.authority = window.location.host
  `
  document.head.appendChild(ruralityAuthConfigScript)
})
